import { Checkbox, CheckboxProps } from 'zens-storybook'
import React from 'react'

interface Props extends Omit<CheckboxProps, 'onChange'> {
  onChange?: (value: boolean) => void
}
const FormCheckbox = (props: Props) => {
  const { onChange, ...otherProps } = props
  return <Checkbox onValueChange={onChange} {...otherProps} />
}

export default FormCheckbox
